// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:35:33

export default {
  "id": "ng-flow-lines",
  "slug": "ng-flow-lines",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e212643354b348d8a5e3c63d19428dd0-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e212643354b348d8a5e3c63d19428dd0/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "NG: Flow Lines",
      "description": "Flow Lines is an engaging and straightforward puzzle game where the main objective is to connect dots of the same color through a continuous path on a grid.",
      "instructions": "To play Flow Lines, tap on a colored dot and drag your finger across the screen to create a path connecting it to another dot of the same color. Ensure that the lines are continuous and do not overlap. The goal is to fill every square on the grid without ",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "relaxing",
        "slide",
        "sliding-puzzle"
      ]
    },
    "zh-CN": {
      "title": "NG：流动线路",
      "description": "Flow Lines是一款引人入胜且简单的益智游戏，主要目标是通过网格上的连续路径连接相同颜色的点。",
      "instructions": "要玩Flow Lines，点击一个彩色圆点，并用手指在屏幕上拖动以创建一条连接到相同颜色圆点的路径。确保线条是连续的，不要重叠。目标是填满网格上的每一个方块，而不",
      "genres": [
        "拼图"
      ],
      "tags": [
        "轻松",
        "滑动",
        "滑动拼图"
      ]
    },
    "zh-TW": {
      "title": "NG：流水線",
      "description": "Flow Lines 是一款引人入勝且簡單直接的拼圖遊戲，主要目標是透過網格上的連續路径將同色點連接起來。",
      "instructions": "要玩Flow Lines，請點擊一個顏色的點並用手指在螢幕上拖動以創建一條連接到同色點的路径。確保線條是連續的且不重疊。目標是填滿格子上所有的方格，而不",
      "genres": [
        "謎題"
      ],
      "tags": [
        "放鬆",
        "滑動",
        "滑動拼圖"
      ]
    },
    "zh-HK": {
      "title": "NG: 流線",
      "description": "Flow Lines 是一款吸引人且簡單的益智遊戲，主要目標是通過一個網格上的連續路徑將同色點連接起來。",
      "instructions": "玩「流線路」遊戲，請點擊一個彩色點並用手指在螢幕上拖動，創建一條連接到相同顏色點的路径。確保線條連續且不交叉。目標是填滿格子的每一個方格，而不",
      "genres": [
        "謎題"
      ],
      "tags": [
        "輕鬆",
        "滑動",
        "滑動拼圖"
      ]
    },
    "ja": {
      "title": "NG: フロー・ライン",
      "description": "Flow Linesは、同じ色の点をグリッド上の連続した経路で結ぶことを目的とした、楽しく簡単なパズルゲームです。",
      "instructions": "Flow Linesをプレイするには、色の異なる点をタップして、指でスクリーンを横切って同じ色の点に道を作成します。線は連続で重なってはいけません。目標はグリッド上のすべての四角形を埋めることです。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "リラックス",
        "スライド",
        "スライディングパズル"
      ]
    },
    "ko": {
      "title": "NG: 플로우 라인",
      "description": "플로우 라인즈는 직관적이고 흥미로운 퍼즐 게임으로, 주요 목표는 그리드 상에서 같은 색의 점을 연속적인 경로를 통해 연결하는 것입니다.",
      "instructions": "플로우 라인을 플레이하려면, 색상이 같은 점을 탭하고 화면을 지그시 길게 터치하여 다른 색상의 점과 연결하는 경로를 만들어주세요. 선이 연속적이고 겹치지 않도록 주의하세요. 목표는 그리드의 모든 칸을 채우는 것입니다.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "휴식",
        "슬라이드",
        "슬라이딩 패ズل"
      ]
    },
    "fr": {
      "title": "NG : Lignes de flux",
      "description": "Flow Lines est un jeu de puzzle captivant et direct où l'objectif principal est de connecter des points de la même couleur par un chemin continu sur une grille.",
      "instructions": "Pour jouer à Flow Lines, appuyez sur un point de couleur et glissez votre doigt sur l'écran pour créer un chemin le reliant à un autre point de la même couleur. Assurez-vous que les lignes sont continues et ne se chevauchent pas. L'objectif est de remplir chaque case du grillage sans",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "relaxant",
        "glisser",
        "puzzle de glissement"
      ]
    }
  }
};
